var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toUpdateDel"},[_c('div',{staticClass:"posts",domProps:{"innerHTML":_vm._s(_vm.Delarr.posts)}})])}
var staticRenderFns = []

export { render, staticRenderFns }